import React, { useState } from "react";
import { Container, Typography, Snackbar, Button, Grid } from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import ForgetPasswordForm from "../../molecules/ForgetPasswordForm";
import "./style.css";
import success from "../../../imgs/succes.svg";
import { forgotPassword } from "../../../api/services/services";
import { useNavigate } from "react-router-dom";

const ForgetPasswordPage = () => {
  const [isForget, setIsForget] = useState(true);
  const [isSuccess, setIsSuccess] = useState(false);

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const navigate = useNavigate();

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const handleForgetPassword = (formData) => {
    const body = {
      email: formData?.email,
    };

    forgotPassword(body)
      .then((response) => {
        setIsForget(false);
        setIsSuccess(true);
      })
      .catch((error) => {
        console.error("Error creating password:", error);
        setSnackbarMessage(error?.response?.data?.message || "Something went wrong");
        setOpenSnackbar(true);
      });
  };

  return (
    <div className="login-split-container">
      {/* Left Panel: The Brand Experience */}
      <div className="brand-panel">
        <div className="brand-content">
          <Typography variant="h1" className="brand-title">
            Shelozon Digital
          </Typography>
          <Typography variant="h5" className="brand-tagline">
            Securely recover your access.
          </Typography>
        </div>
      </div>

      {/* Right Panel: The Functional Form */}
      <div className="form-panel">
        <Container maxWidth="xs" className="form-container">
          {isForget && (
            <>
              <div className="form-header">
                <Typography variant="h4" className="form-title">
                   Forgot Password
                </Typography>
                <Typography variant="body1" className="form-desc">
                   Don't worry, it happens. Enter your email to receive recovery instructions.
                </Typography>
              </div>
              
              <ForgetPasswordForm onSubmit={handleForgetPassword} />

              <div style={{ textAlign: 'center', marginTop: '2rem' }}>
                  <Button 
                    onClick={() => navigate('/login')} 
                    sx={{ textTransform: 'none', color: '#64748b' }}
                  >
                    Back to Login
                  </Button>
              </div>
            </>
          )}

          {isSuccess && (
            <div className="success-container">
                <img
                  src={success}
                  alt="Success"
                  width="84"
                  height="84"
                  className="mb-4"
                />
                <Typography variant="h5" className="success-title">
                    Email Sent
                </Typography>
                <Typography variant="body1" className="form-desc mb-5">
                    We've sent recovery instructions to your email address.
                </Typography>
                <Button
                  type="submit"
                  variant="contained"
                  className="submit-btn"
                  onClick={() => navigate("/login")}
                  fullWidth
                >
                  Return to Login
                </Button>
            </div>
          )}
        </Container>
      </div>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000} // Adjust the duration as needed
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          severity={
            snackbarMessage?.includes("successful") ? "success" : "error"
          }
          onClose={handleCloseSnackbar}
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </div>
  );
};

export default ForgetPasswordPage;
